import {
  transformEmptyPhoneNumber,
  validateGeolocalization,
  validatePassword,
  validatePhoneNumber,
} from '@utils/formHelpers';
import * as z from 'zod';
import { DateSchemaProps, InputSchemaProps, SelectSchemaProps } from './types';
import { Option } from '@contexts/dropdowns/types';

export const hasUnknownOption = (options: Option[], value: string) => {
  if (!options.length) return false;
  return Boolean(value && !options.some((el) => [el.name, el.value].includes(value)));
};

const input = (props?: InputSchemaProps) =>
  z
    .string()
    .trim()
    .refine((v) => (props?.required ? v : true), {
      message: props?.name ? `${props.name}.required` : 'default.input.required',
    })
    .refine((v) => (props?.type === 'geo' ? (v ? validateGeolocalization(v) : true) : true), {
      message: 'geolocalization.incorrect',
    })
    .transform((v) => (props?.type === 'phone' ? transformEmptyPhoneNumber(v) : v))
    .refine((v) => (props?.type === 'phone' ? validatePhoneNumber(v, !props?.required) : true), {
      message: 'phoneNumber.incorrect',
    })
    .refine(
      (v) => (props?.type === 'email' && v ? z.string().trim().email().safeParse(v).success : true),
      {
        message: 'email.incorrect',
      },
    )
    .refine((v) => (props?.type === 'password' ? validatePassword(v) : true), {
      message: 'password.incorrect',
    });
const number = () => z.number();

const date = (props?: DateSchemaProps) =>
  z
    .date()
    .nullable()
    .refine((v) => (props?.required ? v !== null : true), {
      message: 'date.required',
    })
    .optional();

const select = (props?: SelectSchemaProps) =>
  z.preprocess(
    (v) => v ?? '',
    z
      .string()
      .refine((el) => (props?.required ? el : true), {
        message: props?.name ? `${props.name}.required` : 'default.select.required',
      })
      .refine(
        (el) => (props?.disableValueCheck ? true : !hasUnknownOption(props?.options || [], el)),
        {
          message: 'default.select.invalid',
        },
      ),
  );

const boolean = () => z.boolean().optional();

export const schema = { input, select, boolean, number, date };
